import React from "react";
import {GridCell, gridConstants} from "../../Components/Grid";
import {
    Button, checkAndSetError, clearInputFormErrorFields,
    convertInputFormToObject,
    EmailField,
    InputForm, inputFormIsValid,
    PasswordField,
    useInputForm,
} from "../../Components/Inputs";
import {Link} from "../../Components/Link";
import {locations} from "../../Utilities/Location";
import {signInModel, userModel} from "../User/userFactory";

interface SignInViewProps {
    handleSignIn: (signInModel: Record<string, unknown>) => void;
    isLoading: boolean;
    setWarnings: (val: string[]) => void;
}

export const SignInView: React.FC<SignInViewProps> = ({handleSignIn, isLoading, setWarnings}) => {
    const signInForm = useInputForm(signInModel());

    const isFormValid = () => {
        clearInputFormErrorFields(signInForm);

        checkAndSetError([
            signInForm.email,
            signInForm.password,
        ]);

        let isValid = inputFormIsValid(signInForm);

        if (!isValid)
            setWarnings(["Missing required items.  Please review your responses and try submitting again."]);

        return isValid;
    };

    const handleClickSubmit = () => {
        if (isFormValid()) {
            const signIn = convertInputFormToObject(signInForm);
            const user = userModel(signIn);
            handleSignIn(user);
        }
    };

    return <>
        <InputForm name={"signIn"}>
            <EmailField {...signInForm.email} />

            <PasswordField {...signInForm.password} />
            <GridCell>
                <Button
                    isPrimary
                    name="btnSubmit"
                    label="Submit"
                    onClick={handleClickSubmit}
                    disabled={isLoading}
                />
            </GridCell>

            <GridCell small_columns={gridConstants.column.SIX}>
                <p>
                    <Link {...locations.FORGOT_PASSWORD.link} />
                </p>
            </GridCell>
            <GridCell small_columns={gridConstants.column.SIX}>
                {
                    <p className={`align-right`}>
                        <Link {...locations.REGISTER.link} />
                    </p>
                }
            </GridCell>
        </InputForm>
    </>;
};
